import React from 'react'
import { BreadCrumb } from './BreadCrumb'
import { EventGallery } from './EventGallery'

export const Events = () => {
    return (
        <div>
            <BreadCrumb/>
            <EventGallery/>
        </div>
    )
}
